import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Navbar from "@components/Navbar";
import { colors } from "../../utils";
import { device } from "../../utils/device";
import GalleryHeader from "../WheelGallery/Header/GalleryHeader";
import { useSelector } from "react-redux";
import {
  selectPrimaryWheel,
  selectProfile,
} from "../../redux/reducers/gallery";
import { getLatestWheelToShowInReferModal } from "../../services/api";
import { getLoggedInUser } from "../../utils/helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
`;

const ColumnContainer = styled.div`
  display: flex;
  max-width: 100vw;
  justify-content: space-between;
  overflow: hidden;
  height: 90vh;
`;

const LeftColumn = styled.div`
  width: 21%;

  @media ${device.sm} {
    display: none;
  }
`;

const RightColumn = styled.div`
  height: 100%;
  width: 21%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const CenterColumn = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 5px;
  overflow: scroll;
`;

const HeaderRow = styled.div`
  height: 10vh;
`;

const Wrapper = ({
  leftContent,
  centerContent,
  rightContent,
  headerRow,
  style,
  onYugaLogoClick = false,
  isUserProfile = false,
  fullSize = false,
}) => {
  const profile = useSelector(selectProfile);
  const [myWheelToRender, setMyWheelToRender] = useState(null);

  // build a sorted segments array for the LOGGED-IN user's wheel
  const myWheelUpdatedData = useMemo(
    () =>
      myWheelToRender?.wheel_segments?.length > 0
        ? myWheelToRender.wheel_segments.map((obj) => ({ ...obj }))
        : [],
    [myWheelToRender?.wheel_segments]
  );

  const myWheelUpdatedDataSorted = useMemo(
    () =>
      myWheelUpdatedData.length > 0
        ? [...myWheelUpdatedData].sort((a, b) => a.position - b.position)
        : [],
    [myWheelUpdatedData]
  );

  const primaryWheel = useSelector(selectPrimaryWheel);

  useEffect(() => {
    const loggedInUserId = getLoggedInUser()?.id;
    if (!loggedInUserId) {
      setMyWheelToRender(null);
      return;
    }

    const fetchMyLatest = async () => {
      const response = await getLatestWheelToShowInReferModal(loggedInUserId);
      if (response?.data?.data?.id) {
        setMyWheelToRender(response.data.data);
        return;
      }
      setMyWheelToRender(null);
    };

    fetchMyLatest();
    // re-run if primary wheel changes (e.g., user updates it)
  }, [primaryWheel]);
  return (
    <Container>
      <GalleryHeader
        isUserProfile={isUserProfile}
        wheelUpdatedDataSorted={myWheelUpdatedDataSorted}
      />
      <ColumnContainer style={style}>
        {!fullSize && <LeftColumn>{leftContent}</LeftColumn>}
        <CenterColumn>{centerContent}</CenterColumn>
        {!fullSize && rightContent && <RightColumn>{rightContent}</RightColumn>}
      </ColumnContainer>
    </Container>
  );
};

export default Wrapper;
